<script lang='ts' setup>
import type { HTMLAttributes } from 'vue'
import type { PrimitiveProps } from 'reka-ui'

import { cn } from 'cn'
import { Primitive } from 'reka-ui'

import type { BubbleVariants } from './variants'

import { bubbleVariants } from './variants'

interface Props extends PrimitiveProps {
  variant?: BubbleVariants['variant']
  align?: 'start' | 'end'
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
  align: 'start',
  as: 'div',
})
</script>

<template>
  <Primitive
    data-slot="bubble"
    :data-variant="variant"
    :data-align="align"
    :as
    :as-child
    :class="cn(bubbleVariants({ variant }), props.class)"
  >
    <slot />
  </Primitive>
</template>
